import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useHelpModalState } from 'react-commons';
import { Props } from '../BusinessType';
import { useSetFlow, usePartnerParams, useStyles } from '../../Shared';
import { useGlobalState } from '../../../state/persistence';
import { BusinessTypeEnum } from '../../../types';

const useBusinessType = ({ flow, nextUrl }: Props) => {
  const { t } = useTranslation('business_type');
  const { toggleHelpModal } = useHelpModalState();

  usePartnerParams();
  useSetFlow(flow);

  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();

  const onClick = (type: BusinessTypeEnum) => {
    dispatchQuestion('businessType', type);

    history.push(nextUrl);
  };

  return {
    t,
    classes: useStyles(),
    onClick,
    toggleHelpModal,
  };
};

export default useBusinessType;
